/**
 * @package PIANO
 *
 */
(function (window, document, undefined) {

  var PIANO = {};

  var VERSION = '2';

  PIANO.getVersion = function () {
    return VERSION;
  }

  function expose() {
    var oldPIANO = window.PIANO;

    PIANO.noConflict = function () {
      window.PIANO = oldPIANO;
      return this;
    };

    window.PIANO = PIANO;
  }

  if (typeof module === 'object' && typeof module.exports === 'object') {
    module.exports = PIANO;
  } else if (typeof define === 'function' && define.amd) {
    define(PIANO);
  }

  if (typeof window !== 'undefined') {
    expose();
  }

}(window, document));
